import { HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { AppClientConfiguration, TranslationService } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { LegendPosition, MapConfigurationDetails, UploadMapFileServiceResponse } from '../../yard-map-configuration-model';

@Component({
  selector: 'app-map-details',
  templateUrl: './map-details.component.html',
  styleUrls: ['./map-details.component.scss']
})
export class MapDetailsComponent implements OnInit {

  /** Shows loading spinner i.e. when deletion is triggered and validation request is running. */
  requestRunning = false;

  detailsForm: FormGroup;

  _configuration: MapConfigurationDetails;

  legendPositionOptions = new Array<LegendPosition>();

  @Input() set configuration(configuration: MapConfigurationDetails) {

    this._configuration = configuration;

    if (this._configuration != null) {
      this.detailsForm.reset({ width: configuration.width, height: configuration.height, legendPosition: configuration.legendPosition });
      this.detailsForm.controls.width.enable();
      this.detailsForm.controls.height.enable();
      this.detailsForm.controls.legendPosition.enable();
    } else {
      this.detailsForm.reset({ height: null, width: null });
      this.detailsForm.controls.width.disable();
      this.detailsForm.controls.height.disable();
      this.detailsForm.controls.legendPosition.enable();
    }
  }

  constructor(
    public translationService: TranslationService,
    private appServerAPI: AppServerAPI,
    private appClientConfiguration: AppClientConfiguration) {

    this.initForm();

  }

  ngOnInit(): void {
  }

  private initForm() {

    for (const key of Object.keys(LegendPosition)) {
      this.legendPositionOptions.push(LegendPosition[key]);
    }

    this.detailsForm = new FormGroup({
      width: new FormControl(null, [Validators.required]),
      height: new FormControl(null, [Validators.required]),
      legendPosition: new FormControl(null, [Validators.required]),
    });

    this.detailsForm.valueChanges.subscribe(
      value => {
        if (this.detailsForm.dirty && this._configuration != null) {
          this._configuration.width = this.detailsForm.controls.width.value;
          this._configuration.height = this.detailsForm.controls.height.value;
          this._configuration.legendPosition = this.detailsForm.controls.legendPosition.value;
          this._configuration.dirty = true;
        }
      }
    );
  }

  handleMapChangeEvent(event: Event) {
    this.requestRunning = true;
    const files = (event.target as HTMLInputElement).files;
    if (files != null) {
      for (let i = 0; i < files.length; i++) {
        const current: File = files.item(i);
        const name = current.name;
        const type = current.type;
        const reader = new FileReader();
        reader.onload = () => {
          try {
            this.saveMapFile(type, name, reader.result);
          } catch (e) {
            console.log('saveMapFile call failed:', e);
          }
        };
        reader.readAsArrayBuffer(current);
      }
    }
  }

  private saveMapFile(type: string, name: string, content: any) {
    this.appServerAPI.postFile<UploadMapFileServiceResponse>(
      `/client/admin/yardmap/upload`, content, new HttpHeaders({
        'Content-Type': type,
        'Content-MD5': 'test', // TODO: Calculate MD5 hash of capture.blob
        filename: encodeURIComponent(name),
        // Authorization: authHeader
      })).subscribe(response => {
        console.log('saveMapFile call succeeded:', response);
        this._configuration.mapResourceUUID = response.mapResourceUUID;
        this._configuration.mapURL = this.appClientConfiguration.serverURLRoot + '/client/resource/archive/' + response.mapResourceUUID;
        this._configuration.dirty = true;
        this.requestRunning = false;
      }, error => {
        console.log('saveMapFile call failed:', error);
        this.requestRunning = false;
      });
  }
}
